import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/format';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  hoverable?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

export function Card({
  hoverable = false,
  padding = 'md',
  className,
  children,
  ...rest
}: CardProps) {
  const padClass = { none: '', sm: 'p-4', md: 'p-6', lg: 'p-8' }[padding];
  return (
    <div className={cn('card', hoverable && 'card-hoverable', padClass, className)} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('mb-4 pb-4 border-b border-line', className)}>
      {children}
    </div>
  );
}

export function CardTitle({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <h3 className={cn('text-subhead font-display font-semibold text-ink', className)}>
      {children}
    </h3>
  );
}

export function CardDescription({ children, className }: { children: ReactNode; className?: string }) {
  return <p className={cn('text-small text-ink-subtle mt-1', className)}>{children}</p>;
}
